import { createContext, useContext } from 'react';

const ProductDetailContext = createContext(null);

const ProductDetailContextProvider = ({
  getProductDetail,
  getMmuSkuList,
  setShowLoading,
  children,
}) => {
  return (
    <ProductDetailContext.Provider value={{ getProductDetail, getMmuSkuList, setShowLoading }}>
      {children}
    </ProductDetailContext.Provider>
  );
};

const useProductDetailContext = () => {
  const context = useContext(ProductDetailContext);
  if (context === undefined) {
    throw new Error('useProductDetailContext must be used within a ProductDetailContextProvider');
  }
  return context;
};

export { ProductDetailContextProvider, useProductDetailContext };
